/**
 * True for the federation portal (`/federation` and everything under `/federation/<slug>/...`),
 * which renders its own shell. The public `/federation/<slug>/register` redirect pages share the
 * prefix but are marketing entry points, not the portal.
 */
export function isFederationPortalPath(normalizedPathname: string, locale: string): boolean {
  const base = `/${locale}/federation`;
  if (normalizedPathname === base) return true;
  if (!normalizedPathname.startsWith(`${base}/`)) return false;
  const rest = normalizedPathname.slice(base.length + 1).split('/');
  return rest[1] !== 'register';
}
